import {
	ExxonMobilFVIPipingCoverData,
	ProgressChange,
	ReportApiData,
} from '../utils/models';

import httpService from './httpService';
import logger from './logService';

function acceptReport(
	id: string,
	data: { acceptanceStatus: string; reviewComment: string; commentDocumentUrl?: string; },
	onUploadProgress: ProgressChange
) {
	return httpService.post('/report/accept/' + id, data, { onUploadProgress });
}

function addInspectedItemsToProject(
	projectId: string,
	inspectedItems: string[],
	abortSignal: AbortSignal
) {
	return httpService.post(
		'/project/add-inspection-item/' + projectId,
		{ inspectionItemId: inspectedItems },
		{ signal: abortSignal }
	);
}

function approveReport(
	id: string,
	data: { reportStatus: string; reviewComment: string },
	onUploadProgress: ProgressChange
) {
	return httpService.post('/report/approve/' + id, data, { onUploadProgress });
}

function clientReview(
	reportId: string,
	data: { customerReviewStatus: string; reviewComment: string; reviewCommentDocumentUrl: string; },
	onUploadProgress: ProgressChange
) {
	return httpService.post('/report/customer-review/' + reportId, data, { onUploadProgress });
}

function createReport(data: ReportApiData, onUploadProgress: ProgressChange) {
	return httpService.post('/report/', data, { onUploadProgress });
}

async function updateReportLastPhotoNumber(payload: { projectId: string; lastReportPhotoNumber: number; }) {
	try {
		await httpService.post('/report/append-number', payload);
	} catch (error) {
		logger.log(error as Error);
	}
}

function importReport(data: any, onUploadProgress: ProgressChange) {
	return httpService.post('/report/import-report', data, { onUploadProgress });
}

function getAuditTrail(reportId: string) {
	return httpService.get('/report/audit-trail/' + reportId);
}

function getReportAuditTrail(projectId: string) {
	return httpService.get('/project/progress-trail/' + projectId).then(response => response.data);
}

function getFVIPipingReportCoverData(id: string) {
	return httpService.get<ExxonMobilFVIPipingCoverData>('/metadata/' + id);
}

function createFVIPipingReportCoverData(data: ExxonMobilFVIPipingCoverData) {
	return httpService.post('/metadata', data);
}

function updateFVIPipingReportCoverData(metadataId: string, data: ExxonMobilFVIPipingCoverData) {
	return httpService.put('/metadata/' + metadataId, data);
}

function getReport(reportId: string) {
	return httpService.get('/report/' + reportId);
}

function saveReportProgress(
	data: { projectId: string; savedProgressUrl: string },
	signal: AbortSignal
) {
	return httpService.post('/report/save-progress', data, { signal });
}

function submitReview(id: string, data: { reviewStatus: string; reviewComment: string }, onUploadProgress: ProgressChange) {
	return httpService.post('/report/review/' + id, data, { onUploadProgress });
}

function updateReport(reportId: string, data: ReportApiData, onUploadProgress: ProgressChange) {
	return httpService.put('/report/update/' + reportId, data, {
		onUploadProgress,
	});
}

function uploadProjectUrl(projectId: string, projectUrl: string, signal: AbortSignal) {
	return httpService.post('/project/url/' + projectId, { projectUrl }, { signal });
}

export {
	acceptReport,
	addInspectedItemsToProject,
	approveReport,
	createReport,
	createFVIPipingReportCoverData,
	getAuditTrail,
	getFVIPipingReportCoverData,
	getReport,
	getReportAuditTrail,
	importReport,
	saveReportProgress,
	submitReview,
	updateReport,
	clientReview,
	updateFVIPipingReportCoverData,
	updateReportLastPhotoNumber,
	uploadProjectUrl,
};
